import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { EstadoPlanificacionConSolicitud, PlanificacionSolicitudVacaciones, TiposReplanificacion } from './TypesSolicitudVacaciones'
import { Button, Card, CardTitle, CardBody, CardFooter, Container, Row, Col, Table, Input, FormGroup, Label } from "reactstrap";
import { ObtenerFechaFromIsoFormat, PruebaSolucion2 } from 'functions/DatesFunctions';
import { CheckPlanificacion } from './SolicitudVacaciones';
import TablePlanificaciones from './TablePlanificaciones';

//Contexto para solicitudes
import { useSolicitudVacacionesContext } from 'Context/SolicitudesVacacionesContext';



type PropsCardPlanificaciones = {
  planificaciones: PlanificacionSolicitudVacaciones[],
  anioPlanificacion: number,
  handleCheckPlanificacion: (p: PlanificacionSolicitudVacaciones | undefined) => void,
  planificacionVerificar?: CheckPlanificacion,
  onClickMostrarReplanificacion: () => void

}

// type StateCardPlanificaciones = {
//     planificacionSeleccionada?:PlanificacionSolicitudVacaciones,
//     accionRealizada:string
// }


export default function CardPlanificaciones(props: PropsCardPlanificaciones) {


  // const defaultStateCardPlanificaciones:StateCardPlanificaciones ={
  //   accionRealizada:""
  // }


  const [planificacionesstate, setplanificacionesstate] = useState<PlanificacionSolicitudVacaciones[]>([])
  const [planificacionSeleccionada, setplanificacionSeleccionada] = useState<PlanificacionSolicitudVacaciones | undefined>()
  //States para Select de Acciones
  const [accionRealizada, setaccionRealizada] = useState<string>("")

  //Hooks del contexto de solicitudVacaciones
  const {bloquearChecks,mostrarModalReplanificacion} = useSolicitudVacacionesContext();


  useEffect(() => {
    setplanificacionesstate(props.planificaciones)
  }, [props.planificaciones])



  useEffect(() => {

    // if (accionRealizada !== undefined && accionRealizada !== "" && planificacionSeleccionada !== undefined) {
    //   props.handleCheckPlanificacion(planificacionSeleccionada, accionRealizada)

    // }


    props.handleCheckPlanificacion(planificacionSeleccionada)

  }, [planificacionSeleccionada, accionRealizada])





  // function HandleCheckCelda(planificacionSeleccionada: PlanificacionSolicitudVacaciones, e: React.ChangeEvent<HTMLInputElement>) {
  //   if (e.target.checked) {
  //     setplanificacionSeleccionada(planificacionSeleccionada)

  //   }
  //   else {
  //     setplanificacionSeleccionada(undefined)

  //   }
  // }


  // const celdaCheck = useCallback(
  //   (tomadas: boolean, p: PlanificacionSolicitudVacaciones) => {

  //     var fechaParseada = planificacionVerificar?.fechaDesde;
  //     if (planificacionVerificar !== undefined && planificacionVerificar.fechaDesde !== null) {
  //       fechaParseada = PruebaSolucion2(planificacionVerificar.fechaDesde).split(".")[0];
  //     }




  //     var eligioFechaDistinta: boolean = (planificacionVerificar !== undefined && planificacionSeleccionada !== undefined && planificacionVerificar.fechaDesde !== null && fechaParseada !== planificacionSeleccionada.fechaInicio.toString())
  //     var isCheck: boolean = (tomadas || planificacionSeleccionada?.fechaInicio === p.fechaInicio) && !eligioFechaDistinta;


  //     var isDisabled: boolean = tomadas || new Date().getTime() > new Date(p.fechaInicio).getTime()


  //     if (isCheck) {
  //       return (
  //         <input type="checkbox" checked={isCheck} disabled={isDisabled} onChange={(e) => HandleCheckCelda(p, e)} ></input>
  //       )
  //     }
  //     else {
  //       return (
  //         <input type="checkbox" checked={isCheck} disabled={isDisabled} onChange={(e) => HandleCheckCelda(p, e)}></input>
  //       )
  //     }
  //   }, [planificacionesstate, planificacionSeleccionada, planificacionVerificar])


  // const onClickChangeAccion = useCallback(
  //   (value: string, planificacionSeleccionada?: PlanificacionSolicitudVacaciones) => {
  //     setplanificacionSeleccionada(planificacionSeleccionada)
  //     setaccionRealizada(value);
  //   },[accionRealizada,planificacionSeleccionada,props],
  // )

  // function onClickChangeAccion(value: string, planificacionSeleccionada?: PlanificacionSolicitudVacaciones) {
  //   setplanificacionSeleccionada(planificacionSeleccionada)
  //   setaccionRealizada(value);
  // }

  function HandleCheckCelda(ischecked: boolean, planificacionSeleccionada?: PlanificacionSolicitudVacaciones) {
    if (ischecked) {
      setplanificacionSeleccionada(planificacionSeleccionada)

    }
    else {
      setplanificacionSeleccionada(undefined)

    }
  }




  const select = useCallback((plAnio: PlanificacionSolicitudVacaciones) => {

    const { planificacionVerificar } = props;

    const fechaActual = new Date();
    var fechaParseada = planificacionVerificar?.fechaDesde;
    if (planificacionVerificar !== undefined && planificacionVerificar.fechaDesde !== null) {
      fechaParseada = PruebaSolucion2(planificacionVerificar.fechaDesde).split(".")[0];
    }
    //console.log(fechaParseada)

    const cambioLaFechaLuegoDeEscogerla: boolean = (fechaParseada !== undefined && fechaParseada !== null && fechaParseada.toString() !== plAnio.fechaInicio.toString())
    // const accionEnElPresenteSelect: boolean = plAnio.fechaInicio.toString() === planificacionSeleccionada?.fechaInicio.toString() && !cambioLaFechaLuegoDeEscogerla
    // const valueDelInput = accionEnElPresenteSelect ? accionRealizada : "";


    const fechaPasada = new Date(plAnio.fechaInicio).getTime() < fechaActual.getTime()
    var disabled = plAnio.tomadas || fechaPasada;







    const ComponenteSelectAcciones = (
      <input type='checkbox' disabled={disabled}  >  </input>
    )


    //   <Input
    //   id="accionesSelect"
    //   name="accionesPlanificacion"
    //   type="select"
    //   value={valueDelInput}
    //   onChange={(e) => onClickChangeAccion(e.target.value, plAnio)}
    //   disabled={disabled}
    // >
    //   <option defaultValue={""}>{"ESCOJA UNA OPCIÓN"} </option>
    //   <option value={"SOL"}  >SOLICITAR</option>
    //   {/* <option value={TiposReplanificacion.REPLANIFICACION}  >REPLANIFICAR</option>
    //   <option value={TiposReplanificacion.REPLANIFICACIONSOLICITADA}  >REPLANIFICAR Y SOLICITAR</option> */}
    // </Input>



    return ComponenteSelectAcciones;

  }, [planificacionesstate, planificacionSeleccionada, props.planificacionVerificar, accionRealizada])


  const celdaCheck = useCallback(
    (p: PlanificacionSolicitudVacaciones) => {

      const { planificacionVerificar } = props;
      const tomadas = p.tomadas;
      var fechaParseada = planificacionVerificar?.fechaDesde;


      if (planificacionVerificar !== undefined && planificacionVerificar.fechaDesde !== null) {
        fechaParseada = PruebaSolucion2(planificacionVerificar.fechaDesde).split(".")[0];
      }


      var eligioFechaDistinta: boolean = (planificacionVerificar !== undefined && planificacionSeleccionada !== undefined && planificacionVerificar.fechaDesde !== null && fechaParseada !== planificacionSeleccionada.fechaInicio.toString())
      var isCheck: boolean = (tomadas || planificacionSeleccionada?.fechaInicio === p.fechaInicio) && !eligioFechaDistinta;


      var isDisabled: boolean = tomadas || new Date().getTime() > new Date(p.fechaInicio).getTime() || (p.estadoParse === EstadoPlanificacionConSolicitud.REPLANIFICACION_INGRESADA || p.estadoParse === EstadoPlanificacionConSolicitud.REPLANIFICADA)


      // const verificarFechaCambiada:boolean = planificacionVerificar !== undefined && planificacionSeleccionada !== undefined && planificacionVerificar.fechaDesde === null
      // if (planificacionVerificar !== undefined && planificacionSeleccionada !== undefined && new Date(p.fechaInicio).getTime() === new Date(planificacionSeleccionada.fechaInicio).getTime() && (verificarFechaCambiada || (planificacionVerificar.fechaDesde !== null && new Date(planificacionVerificar.fechaDesde).getTime() !== new Date(p.fechaInicio).getTime()))) {
      //   isCheck = false;

      // }

      // if (isCheck) {
      //   return (
      //     <input type="checkbox" checked={isCheck} disabled={isDisabled} onChange={(e) => HandleCheckCelda(e.target.checked, p)} ></input>
      //   )
      // }
      // else {
      //   return (
      //     <input type="checkbox" checked={isCheck} disabled={isDisabled} onChange={(e) => HandleCheckCelda(e.target.checked, p)}></input>
      //   )
      // }

      if(bloquearChecks){
        isDisabled = true;
      }

      return (
        <input type="checkbox" checked={isCheck} disabled={isDisabled} onChange={(e) => HandleCheckCelda(e.target.checked, p)}></input>        
      )

    }, [planificacionSeleccionada, props.planificacionVerificar,bloquearChecks])



 






  const celdaFecha = (fechaSeparada: undefined | string[]) => {
    if (fechaSeparada) {
      return (
        <>
          <span>{fechaSeparada[0]} </span>
          <span><strong>{fechaSeparada[1]}</strong> </span>

        </>
      )
    }
    else {
      return (<></>)
    }

  }

  const contenidoTabla = useMemo(() => {
    {


      const aniosObtenidos = planificacionesstate
        .map((p) => {
          const anio = +ObtenerFechaFromIsoFormat(p.fechaInicio.toString()).split("/")[2];
          return anio
        })

      const aniosUsados: number[] = [...new Set(aniosObtenidos)];

      const tablaPlanificaciones = aniosUsados.map((anio, indianio) => {


        const planificacionesDelAnio = planificacionesstate.filter(pl => {
            const anioPlanificacion = +ObtenerFechaFromIsoFormat(pl.fechaInicio.toString()).split("/")[2];
            return anioPlanificacion == anio
        });

        const contenidoDelAnio = (
          <React.Fragment key={"row_planificacion_solicitud_anio" + anio}>

            <TablePlanificaciones celdaCheck={celdaCheck} planificacionesDelAnio={planificacionesDelAnio} anio={anio}  />
          </React.Fragment>
        )

        return contenidoDelAnio;
      })

      return tablaPlanificaciones


    }
  }, [planificacionesstate, celdaCheck])

  // }, [planificacionSeleccionada, planificacionesstate, props.planificacionVerificar,select])

  const botonReplanificacion = useMemo(() => {

    const cantidadPlanificaciones = planificacionesstate.length;

    const tienePlanificacionesPendientes = planificacionesstate.find((sol) => sol.estadoParse === EstadoPlanificacionConSolicitud.PENDIENTE) !== undefined;
    const tienePlanificacionesNoEjecutadas = planificacionesstate.find((sol) => sol.estadoParse === EstadoPlanificacionConSolicitud.NO_EJECUTADO) !== undefined;
    const tienePlanificacionesJustificadas = planificacionesstate.find((sol) => sol.estadoParse === EstadoPlanificacionConSolicitud.JUSTIFICADA) !== undefined;

    const puedeReplanificar = tienePlanificacionesPendientes || tienePlanificacionesNoEjecutadas || tienePlanificacionesJustificadas;

    if (planificacionesstate.length > 0 && puedeReplanificar) {
      return (
        <Button disabled={planificacionesstate.find((sol) => sol.estadoParse === EstadoPlanificacionConSolicitud.REPLANIFICACION_INGRESADA) !== undefined} onClick={() => props.onClickMostrarReplanificacion()}>
          <span className='containerTextReprogVac' >
            Reprogramación de vacaciones
          </span>
        </Button>
      )
    }
    else {
      return undefined;
    }



  }, [planificacionesstate])


  useEffect(() => {
    if(mostrarModalReplanificacion){
      props.onClickMostrarReplanificacion()
    }
  }, [mostrarModalReplanificacion,props.onClickMostrarReplanificacion])
  

  return (
    <Card >
      <CardTitle className="cardHeaderPlanificaciones2"  >
        <div>
          Planificación de vacaciones
        </div>

      </CardTitle>
      <CardBody id="card_boy_calendario_directivo">

        {contenidoTabla}
      </CardBody>
      <CardFooter>
        {/* {
          botonReplanificacion
        } */}

      </CardFooter>

    </Card>
  )
}
